<template>
    <modal dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
        <div slot="body" class="p-4">
            <h2 class="text-center mb-3">{{`Duplicate - ${itemRule.item.name}`}}</h2>

            <p class="mb-3">Please insert the new name:</p>

            <div class="form-group row min-height">
                <div class="col-sm-12">
                    <input type="text" class="w-100" v-model="duplicatedRule.name">
                    
                    <div v-if="$v.duplicatedRule.name.$invalid" class="messages error">
                        <span v-if="!$v.duplicatedRule.name.required">New name is required.</span>
                        <span v-if="!$v.duplicatedRule.name.validCharacters">
                            Invalid characters. Please use only letters, numbers, spaces, and the following special characters: <strong>{{specialCharacters}}</strong>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="pressDuplicate" :disabled="isInvalidName || isDuplicatingRule">Duplicate</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import Modal from './Modal'
    import { required, withParams } from "vuelidate/lib/validators";
    import { rulesMixin } from '@/mixins/rules'

    export default {
        data() {
            return {
                duplicatedRule: null,
                specialCharacters: "<>|\\#$%/()=*+-_.:;,€ºª",
                isDuplicatingRule: false
            }
        },
        async mounted() {
            this.$nextTick(() => {
                this.eventHub.$on("closeTargetModal", () => {
                    this.closeModal();
                });
            });
        },
        created() {
            this.duplicatedRule = JSON.parse(JSON.stringify(this.getSelectedRuleItem.item));
            this.duplicatedRule.name = this.duplicatedRule.name + ' duplicated';
        },
        destroyed() {
            this.clearSelectedItemRule();
            this.eventHub.$off('closeTargetModal');
        },
        mixins: [
            rulesMixin,
        ],
        validations: {
            duplicatedRule: {
                name: {
                    required,
                    validCharacters: function (val) {
                        return this.validCharacters(val);
                    }
                }
            },
        },
        computed: {
            ...mapGetters([
                'getSelectedRuleItem'
            ]),
            itemRule() {
                return this.getSelectedRuleItem;
            },
            isInvalidName() {
                return !this.duplicatedRule.name || this.duplicatedRule.name.trim() === "" || this.duplicatedRule.name === null || !this.$v.duplicatedRule.name.validCharacters;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'duplicateRuleOrGroup',
                'clearSelectedItemRule',
                'downloadRules',
                'downloadRulesGroup'
            ]),
            validCharacters(val) {
                const allowedCharacters = /^[a-zA-Z0-9áàâãéêíóôõúçÁÀÂÃÉÊÍÓÔÕÚÇ\s<>|\\#$%\/()=*+\-_.:;,€ºª]*$/;
                
                return allowedCharacters.test(val);
            },
            cancel() {
                this.clearSelectedItemRule();
                this.closeModal();
            },
            pressDuplicate() {
                const ruleType = this.itemRule.type === 'rules' ? 'rules' : 'rulesGroups';
                this.isDuplicatingRule = true;
                
                this.duplicateRuleOrGroup({type: ruleType, item: this.duplicatedRule}).then(success => {
                    this.isDuplicatingRule = false;
                    if (success) {
                        ruleType === 'rules' ? this.downloadRules() : this.downloadRulesGroup();
                        this.showAlert({title: 'Success!', subTitle: 'Rule duplicated properly.'});
                    } else {
                        this.showAlert({title: 'Error!', subTitle: 'Something went wrong. Please try again later.'});
                    }

                    this.clearSelectedItemRule();
                    this.closeModal();
                })
            },
            showAlert(info) {
                this.$dialog.alert(
                    `<div class="d-flex flex-column justify-content-center">
                        <div class="fs-largest font-weight-600 mb-4">${info.title}</div>
                        <div class="bold dark">${info.subTitle}</div>
                    </div>`,
                    { okText: 'Ok'});
            }
        },
        components: {
            Modal,
            Loader
        }
    }
</script>
<style lang="scss" scoped>
    .min-height {
        min-height: 58px;
    }
</style>



// WEBPACK FOOTER //
// RulesDuplicate.vue?4679d463